import React from 'react'
import { PageCustom } from '@ublique/components/Template'
import Filters from '../components/Filters'
import { NS } from '../constants'
import { useTranslation } from 'react-i18next'
import StripeTables from '@ublique/components/Template/components/StripeTables'
import useTableConfig from './hooks/useTableConfig'
import useKpisConfig from './hooks/useKpisConfig'
import StripeKPIs from '@ublique/components/Template/components/StripeKPIs'
import './index.scss'

function FeedbackUtente() {
  const { t } = useTranslation('ExtraOutput')

  const { kpisConfig, refreshKpisData, referencePeriod } = useKpisConfig()
  const tablesConfig = useTableConfig(refreshKpisData)

  return (
    <PageCustom className='feedback-utente-page'>
      <Filters title={t(`${NS}.USER_FEEDBACK`)} roomsFilter />
      <h6 className='reference-period'>{`${t(
        'StoreCollaboration.REFERERENCE_PERIOD'
      )}: ${referencePeriod}`}</h6>
      <StripeKPIs kpis={kpisConfig} className='stripe-kpis-chart' />
      <StripeTables tables={tablesConfig} />
    </PageCustom>
  )
}

export default FeedbackUtente
